function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgStarIconThreeQuarters(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M11.005 0L7.64 6.375.54 7.605l5.023 5.168-1.026 7.135 6.469-3.18 6.468 3.18-1.026-7.135 5.024-5.169-7.103-1.229L11.005 0z",
    fill: props.colorSecondary
  }), /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.537 19.9h.013l-.014.008.001-.007zm11.805-.548V6.717l5.129.887-5.024 5.17 1.026 7.134-1.13-.556z",
    fill: props.color
  }));
}

export default SvgStarIconThreeQuarters;